import mediaRunningReducer from "./mediaRunning/mediaRunning";
import dapp from "../dApp/reducer";
import walletReducer from "./wallet/wallet";

const rootReducers = {
  mediaRunning: mediaRunningReducer,
  dapp: dapp,
  wallet: walletReducer,
};

export default rootReducers;
